import { FuseLoadable } from '@fuse'

export default [
  {
    path: process.env.PUBLIC_URL + '/users-management/activities/:scopeId',
    component: FuseLoadable({
      loader: () => import('./activity/Activity')
    })
  },
  {
    path: process.env.PUBLIC_URL + '/users-management/activities',
    component: FuseLoadable({
      loader: () => import('./list/ActivitiesList')
    })
  }
]
